export default "__VITE_ASSET__Ge73i9GK__"